import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { api } from "../lib/api";
import { toast } from "sonner";
import { HeartHandshake, Send } from "lucide-react";

export function ContributeDialog({ open, onOpenChange, family }) {
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!name.trim()) return toast.error("Please add your name");
    setBusy(true);
    try {
      await api.createContribRequest(name.trim(), note.trim(), family);
      setSent(true);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not send your request");
    } finally { setBusy(false); }
  };

  const close = (o) => { onOpenChange(o); if (!o) { setName(""); setNote(""); setSent(false); } };

  return (
    <Dialog open={open} onOpenChange={close}>
      <DialogContent className="max-w-md" data-testid="contribute-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-serif text-2xl text-[#082D4A]"><HeartHandshake size={20} /> Ask to contribute</DialogTitle>
          <DialogDescription>Request edit access so you can add relatives, photos and stories to the family tree.</DialogDescription>
        </DialogHeader>
        {sent ? (
          <div className="py-6 text-center" data-testid="contribute-success">
            <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-[#E8EEF3] text-[#082D4A]"><HeartHandshake size={26} /></div>
            <p className="font-serif text-lg text-[#082D4A]">Request sent!</p>
            <p className="mt-1 text-sm text-[#64748B]">The family admin will review it and send you a personal invite link to set up your account.</p>
            <Button onClick={() => close(false)} data-testid="contribute-done" className="mt-5 rounded-full bg-[#082D4A] text-white hover:bg-[#08223A]">Done</Button>
          </div>
        ) : (
          <div className="space-y-3">
            <div className="space-y-1">
              <Label className="text-xs">Your name</Label>
              <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Aunt Rose" data-testid="contribute-name" />
            </div>
            <div className="space-y-1">
              <Label className="text-xs">A short note (optional)</Label>
              <Textarea value={note} onChange={(e) => setNote(e.target.value)} placeholder="How are you related? What would you like to add?" rows={3} data-testid="contribute-note" />
            </div>
            <Button onClick={submit} disabled={busy} data-testid="contribute-submit" className="w-full bg-[#D4A017] text-white hover:bg-[#B0850F]">
              <Send size={15} className="mr-1.5" /> {busy ? "Sending…" : "Send request"}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
